/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Paket_S4Inputs */

const en_tut_paket_s4 = /** @type {(inputs: Tut_Paket_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Need more mid-month? Buy run, premium-credit, or chat add-ons from the add-on cards.`)
};

const id_tut_paket_s4 = /** @type {(inputs: Tut_Paket_S4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Butuh tambahan di tengah bulan? Beli add-on run, kredit premium, atau kuota chat dari kartu add-on.`)
};

/**
* | output |
* | --- |
* | "Need more mid-month? Buy run, premium-credit, or chat add-ons from the add-on cards." |
*
* @param {Tut_Paket_S4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_paket_s4 = /** @type {((inputs?: Tut_Paket_S4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Paket_S4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_paket_s4(inputs)
	return en_tut_paket_s4(inputs)
});